import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';

import { LoadingService, LoadingState } from '../../../core/services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss',
})
export class LoadingOverlayComponent implements OnInit {
  private readonly loadingService = inject(LoadingService);

  protected loadingState$!: Observable<LoadingState>;

  ngOnInit(): void {
    this.loadingState$ = this.loadingService.loading$;
  }
}
